import type { Board } from 'chessboard/model/board/types';
import type { API } from 'chessboard/api/config/types';
import type JCE from '@chesscom/js-chess-engine';

/**
 * Create the getPiece method.
 */
export function createGetPiece(context: API.Context) {
  /**
   * Get the piece on a square.
   */
  return function getPiece(square: Board.SanSquare): JCE.Piece.Model | null {
    const { game } = context;

    return game.get(square);
  };
}
